import { BitmapText, Container } from '@pixi/react'
import { Image } from '@slot-nx/core'
import { Assets } from 'pixi.js'
import { SymbolType } from '../domain/game/enum/SymbolType'
import A from '../../asset/images/symbol/A.png'
import J from '../../asset/images/symbol/J.png'
import Q from '../../asset/images/symbol/Q.png'
import K from '../../asset/images/symbol/K.png'
import M1 from '../../asset/images/symbol/M1.png'
import M2 from '../../asset/images/symbol/M2.png'
import M3 from '../../asset/images/symbol/M3.png'
import M4 from '../../asset/images/symbol/M4.png'
import M5 from '../../asset/images/symbol/M5.png'
import S1 from '../../asset/images/symbol/S1.png'
import C1 from '../../asset/images/symbol/C1.png'
import C2 from '../../asset/images/symbol/C2.png'
import { gameConfig } from '../config'
import { SlotSymbolInfo } from '../domain/placeOrder/api/PlaceOrderResponse'

interface SymbolProps {
  x: number
  y: number
  data: SlotSymbolInfo
  alpha?: number
}

const symbolRecords: { [key: string]: { src: string, loadParser?: string } } = {
  M1: { src: M1 },
  M2: { src: M2 },
  M3: { src: M3 },
  M4: { src: M4 },
  M5: { src: M5 },
  A: { src: A },
  J: { src: J },
  Q: { src: Q },
  K: { src: K },
  Multiplier: { src: S1 },
  Bonus: { src: C1 },
  SuperBonus: { src: C2 },
}
Object.values(symbolRecords).forEach((value) => {
  value.loadParser = 'loadTextures'
})
Assets.addBundle('Symbol', symbolRecords)

export const Symbol = (props: SymbolProps) => {
  const alpha = props.alpha ? props.alpha : 1

  return (
    <Container x={props.x} y={props.y} alpha={alpha}>
      <Container name="SpineWrapper">
        <Image
          name="Symbol"
          anchor={0.5}
          x={gameConfig.nodeWidth / 2}
          y={gameConfig.nodeHeight / 2}
          image={SymbolType[props.data.symbol]}
          scale={1}
        />
      </Container>
      <BitmapText
        name="multiplier"
        text="0"
        anchor={[0.5, 0.8]}
        style={{ fontName: 'FontW', fontSize: 36 }}
        y={gameConfig.nodeWidth / 2}
        x={gameConfig.nodeHeight / 2}
        visible={false}
      />
    </Container>
  )
}
